import { AppRoute } from 'app/app.route.const';
import { isString, trimSlahes } from './string';

export const getLinkSrc = (url: string | undefined) => {
  const deafultUrl = AppRoute.Home;
  if (!url || !isString(url)) return deafultUrl;

  const isRelative = !url.includes('http');

  return isRelative ? `http://${trimSlahes(url)}` : url;
};
